import { Grid } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import AppSummarySearchBar from '@/common/components/form-inputs/AppSummarySearchBar';
import AppMultipleDropDownMenu from '@/common/components/form-inputs/AppMultipleDropDownMenu';
import {
	useGetAllEnumListQuery,
	useGetDicListQuery,
	useGetStaffAllListQuery,
} from '@/api/common';
import { useSelector } from 'react-redux';
import { selectMyInfo } from '@/pages/auth/authSlice';
import AppDateRangePicker from '@/common/components/form-inputs/AppDateRangePicker';

export default function MemberInterventionSummaryFilterSection() {
	const { t } = useTranslation();
	const { control } = useFormContext<any>();
	const userInfo = useSelector(selectMyInfo);

	const { data: staffList }: any = useGetStaffAllListQuery(
		userInfo?.currentBranch?.id || '',
		{
			refetchOnMountOrArgChange: true,
			skip: !userInfo?.currentBranch,
		}
	);

	const { data: allEnumList } = useGetAllEnumListQuery(null, {
		refetchOnMountOrArgChange: true,
	});

	const { data: natureDicList } = useGetDicListQuery('nature', {
		refetchOnMountOrArgChange: true,
	});

	return (
		<Grid container rowSpacing={2} columnSpacing={1}>
			{/* <Grid size={3}>
				<AppSummarySearchBar
					name='searchString'
					control={control}
					placeholder={t('common.search')}
				/>
			</Grid> */}
			<Grid size={3}>
				{/* <AppDateRangePicker
					control={control}
					name='dateOfCaseOpen'
					label={t('member.dateCaseOpen') + '*'}
				/> */}
				<AppDateRangePicker
					control={control}
					startDateName='dateRangeStart'
					endDateName='dateRangeEnd'
					label={t('case.dateRange')}
					startDateRules={{ required: t('case.dateRange') }}
					endDateRules={{ required: t('case.dateRange') }}
				/>
			</Grid>
			<Grid size={2}>
				<AppMultipleDropDownMenu
					control={control}
					name='natureList'
					label={t('member.nature')}
					options={(natureDicList?.data || []).map((item: { labelEn: any }) => {
						return {
							...item,
							name: item.labelEn,
						};
					})}
				/>
			</Grid>
			<Grid size={2}>
				<AppMultipleDropDownMenu
					control={control}
					name='additionalList'
					label={t('case.additional')}
					options={(allEnumList?.data.AdditionalEnum || []).map((item: any) => {
						return {
							...item,
							id: item.code,
							name: item.desc,
						};
					})}
				/>
			</Grid>
			<Grid size={2}>
				<AppMultipleDropDownMenu
					control={control}
					name='castNoteStatusList'
					label={t('case.caseNoteStatus')}
					options={(allEnumList?.data.CaseNoteStatusEnum || []).map(
						(item: any) => {
							return {
								...item,
								id: item.code,
								name: item.desc,
							};
						}
					)}
				/>
			</Grid>
		</Grid>
	);
}
